import styled from 'styled-components';
export const Error = styled.div`
  margin-top: 0.75rem;
  color: #ef4444;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
`;
